import React, { useEffect, useState } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";

function Popup({ show, onClose }) {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 100,
    });
    
  }, []);

  if (!show) return null;

  return (
    <div className="popup">
      <div data-aos="zoom-in" className="popup-content col-12 col-md-6 d-flex flex-column justify-content-around">
        <div className='d-flex justify-content-end align-items-center'>
          <span role='button' onClick={onClose}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle" viewBox="0 0 16 16">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
            </svg>
          </span>
        </div>
        <h2  style={{color: "blue", fontSize:"3rem"}} className='text-center'>Join us as a Volunteer!</h2>
        <div className='col-12 d-flex justify-content-center my-5'>
          <p style={{fontWeight:"bold"}} className='col-8 lead lh-sm text-center font-weight-bolder'>The International Mandir Prabhandhak Council (IMPC) invites volunteers to help rejuvenate Indian temples and cultural sites.</p>
        </div>
        <div className='d-flex justify-content-center w-100'>
          <a className='top-button no-underline' href='/join-as-a-volunteer'><button>Click here to Join</button></a>
        </div>
      </div>
    </div>
  );
}

export default Popup;
